import { FadeUp, SlideInLeft } from './Motion.jsx';
import PlatformFlow from './PlatformFlow.jsx';
import MolecularBackground from './MolecularBackground.jsx';

export default function PlatformBanner() {
  return (
    <section className="fullbleed platform-v2">
      <MolecularBackground variant="platform" />

      <div className="platform-v2-inner">
        <SlideInLeft className="platform-v2-copy">
          <span className="pill-badge">THE COMPLETE PLATFORM</span>
          <FadeUp>
            <h2 className="platform-v2-title">One integrated system</h2>
          </FadeUp>
          <p className="platform-v2-text">
            Photosensitizers work alongside purpose-built lasers and optical
            fibres as part of a photodynamic therapy platform, designed so the
            photosensitiser, light source and delivery system work together as
            one integrated solution.
          </p>
        </SlideInLeft>

        <PlatformFlow />
      </div>
    </section>
  );
}